import React from "react";
import { Toolbar } from "../editor/Toolbar";
import { EditorPanels } from "../editor/EditorPanels";
import { CanvasArea } from "./CanvasArea";
import { DeviceBreakpoint } from "../../App";
import "../../styles/components/layout/EditorView.css";

interface EditorViewProps {
  showPreview: boolean;
  canvasSize: DeviceBreakpoint;
}

export const EditorView: React.FC<EditorViewProps> = ({
  showPreview,
  canvasSize,
}) => {
  return (
    <div className={`editor-container ${showPreview ? "preview-mode" : ""}`}>
      <Toolbar />
      <CanvasArea canvasSize={canvasSize} />
      {!showPreview && <EditorPanels />}
    </div>
  );
};
